/**
 * @module nhcmap/layers/KmzLayer
 */
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { KMZ } from './ol-kmz';
import { Style, Fill, Stroke } from 'ol/style';

/**
 * @classdesc
 * Represents a KMZ layer
 */

class KmzLayer {
  /**
   * Create a KMZ layer
   * @param {object} layerConfig 
   * @param {string} productId 
   */
  constructor(layerConfig, productId) {
    this.layerConfig = layerConfig;
    this.productId = productId;
  }

  /**
   * Load a KMZ layer
   * @returns {Promise<object>} layer
   */
  async loadLayer() {
    //console.log("Adding layer: " + this.layerConfig.id);
    const layer = new VectorLayer({
      source: new VectorSource({
        url: this.layerConfig.url,
        format: new KMZ({
          showPointNames: false,
          extractStyles: false,
          extractAttributes: true,
        }),
      }),
      visible: this.layerConfig.visible,
      zIndex: this.layerConfig.zIndex,
    });
    // We assume that KMZ layers are styled using OL expression styles
    if (this.layerConfig.styleModule) {
      const stylePath = `/maps/${this.productId}/styles/`;
      const styleFile = `${this.layerConfig.styleModule}.json`;
      const stylePathFile = `${stylePath}${styleFile}`;
      fetch(stylePathFile)
        .then(response => response.json())
        .then(glStyle => {
          // Apply the style to the KML layer
          layer.setStyle(glStyle);
        });
    }
    return layer;
  }

  async updateLayer(layer) {
    const source = new VectorSource({
      url: this.layerConfig.url,
      format: new KMZ({
        showPointNames: false,
      }),
    });
    layer.setSource(source);
  }
}

export { KmzLayer };